(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setupSkillFinderV2 = (skillRoot) => {
    if (!skillRoot) return;

      const configScript = skillRoot.querySelector('[data-sy-skill-config]');
      let config = {};
      try {
        config = configScript ? JSON.parse(configScript.textContent || '{}') : {};
      } catch (error) {
        config = {};
      }
      const fallbackLink = skillRoot.dataset.fallbackLink || config.fallbackLink || '/collections/all';
      const ringGradientId = `sySkillRingGradient-${Math.random().toString(36).slice(2)}`;
      const card = skillRoot.querySelector('[data-sy-skill-card]');
      const screen = skillRoot.querySelector('[data-sy-skill-screen]');
      const controlsRow = skillRoot.querySelector('.sy-home-one__skill-submit-row');
      const nextButton = skillRoot.querySelector('[data-sy-skill-next]');
      const backButton = skillRoot.querySelector('[data-sy-skill-back]');
      const status = skillRoot.querySelector('[data-sy-skill-status]');
      const progress = skillRoot.querySelector('[data-sy-skill-progress]');
      const progressFill = skillRoot.querySelector('[data-sy-skill-progress-fill]');
      const progressText = skillRoot.querySelector('[data-sy-skill-progress-text]');
      const progressTitle = skillRoot.querySelector('[data-sy-skill-progress-title]');
      const stages = Array.from(skillRoot.querySelectorAll('[data-sy-skill-stage]'));
      const mobileSkillView = window.matchMedia('(max-width: 989px)');

      if (!card || !screen || !nextButton || !backButton || !progress || !progressFill || !progressText) return;

      const icons = {
        money: '<svg viewBox="0 0 24 24"><path d="M4 18V8"/><path d="M9 18V5"/><path d="M14 18v-7"/><path d="M19 18V3"/><path d="M3 20h18"/></svg>',
        creator: '<svg viewBox="0 0 24 24"><path d="m3 11 13-6v14L3 13z"/><path d="M16 9h2.5a2.5 2.5 0 0 1 0 5H16M5 14l1.5 6h3L8 13"/></svg>',
        ai: '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="2"/><path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M18 9h4M2 15h4M18 15h4M10 10h4v4h-4z"/></svg>',
        confidence: '<svg viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9h8M8 12h5"/></svg>',
        life: '<svg viewBox="0 0 24 24"><path d="M20.5 8.8c0 5.4-8.5 10.1-8.5 10.1S3.5 14.2 3.5 8.8A4.5 4.5 0 0 1 12 6.7a4.5 4.5 0 0 1 8.5 2.1z"/><path d="m7.5 11 2.2.1 1.3-2.6 2 5 1.2-2.5h2.3"/></svg>',
        book: '<svg viewBox="0 0 24 24"><path d="M5.5 5.2A2.2 2.2 0 0 1 7.7 3H12v17H7.7a2.2 2.2 0 0 0-2.2 2.2z"/><path d="M18.5 5.2A2.2 2.2 0 0 0 16.3 3H12v17h4.3a2.2 2.2 0 0 1 2.2 2.2z"/></svg>',
        audio: '<svg viewBox="0 0 24 24"><path d="M4 13.5v-1a8 8 0 0 1 16 0v1"/><path d="M6.2 13.5H4.8A2.3 2.3 0 0 0 2.5 15.8v1.4a2.3 2.3 0 0 0 2.3 2.3h1.4z"/><path d="M17.8 13.5h1.4a2.3 2.3 0 0 1 2.3 2.3v1.4a2.3 2.3 0 0 1-2.3 2.3h-1.4z"/></svg>',
        video: '<svg viewBox="0 0 24 24"><rect x="3.5" y="5.5" width="17" height="13" rx="3"/><path d="m10 9.3 5 2.7-5 2.7z"/></svg>',
        tool: '<svg viewBox="0 0 24 24"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v5h5"/><path d="M9.5 12h5"/><path d="M9.5 16h5"/></svg>',
        target: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="m16 8 4-4"/><path d="M20 4v4h-4"/></svg>',
        clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 1.8"/></svg>',
        steps: '<svg viewBox="0 0 24 24"><path d="M5 17h4"/><path d="M9 17V7h5"/><path d="M14 7v10h5"/></svg>',
        spark: '<svg viewBox="0 0 24 24"><path d="M12 2.5 14.6 10l7.4 2-7.4 2L12 21.5 9.4 14 2 12l7.4-2z"/></svg>',
        wallet: '<svg viewBox="0 0 24 24"><path d="M3 6h16a2 2 0 0 1 2 2v11H3z"/><path d="M3 6V4h14v2M15 11h6v5h-6a2.5 2.5 0 0 1 0-5Z"/></svg>',
        income: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9 14.5c.8.7 1.8 1 3 1 1.8 0 3-.8 3-2s-1.1-1.8-3-2c-1.9-.2-3-.8-3-2s1.2-2 3-2c1.2 0 2.2.3 3 1M12 5v14"/></svg>',
        launch: '<svg viewBox="0 0 24 24"><path d="M14 4c3-2 5-1 6-1 0 1 1 3-1 6l-6 6-4-4 5-7ZM9 11l-4 1-2 3 6 1M13 15l-1 4-3 2-1-6M6 18l-2 2"/><circle cx="16" cy="7" r="1"/></svg>',
        sales: '<svg viewBox="0 0 24 24"><path d="M4 19V5M4 19h16M7 15l4-4 3 2 5-6M16 7h3v3"/></svg>',
        invest: '<svg viewBox="0 0 24 24"><path d="M4 19V5M4 19h16M7 15l4-4 3 2 5-6M16 7h3v3"/><circle cx="8" cy="7" r="2"/></svg>',
        audience: '<svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3"/><circle cx="18" cy="9" r="2"/><path d="M3 20c0-4 2.7-7 6-7s6 3 6 7M15 15c3 0 5 2 5 5"/></svg>',
        brand: '<svg viewBox="0 0 24 24"><path d="m12 3 3 3 4 .5.5 4L22 14l-3 3-1 4-4-.5-3.5 2.5-3-3-4-.5-.5-4L.5 12l3-3 1-4 4 .5z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></svg>',
        content: '<svg viewBox="0 0 24 24"><path d="M5 3h10l4 4v14H5zM14 3v5h5"/><path d="m9 16 1.2-3.2 6.3-6.3 2 2-6.3 6.3z"/></svg>',
        tag: '<svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-7 7z"/><circle cx="8" cy="8" r="1.5"/></svg>',
        automation: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/><path d="M9 6h5a4 4 0 0 1 4 4v1M15 18h-5a4 4 0 0 1-4-4v-1M15 8l3 3 3-3M9 16l-3-3-3 3"/></svg>',
        code: '<svg viewBox="0 0 24 24"><path d="m8 5-6 7 6 7M16 5l6 7-6 7M14 3l-4 18"/></svg>',
        rocket: '<svg viewBox="0 0 24 24"><path d="M14 4c3-2 5-1 6-1 0 1 1 3-1 6l-6 6-4-4 5-7ZM9 11l-4 1-2 3 6 1M13 15l-1 4-3 2-1-6M6 18l-2 2"/><circle cx="16" cy="7" r="1"/></svg>',
        wrench: '<svg viewBox="0 0 24 24"><path d="M14.5 6.5a5 5 0 0 0-6.8 6.8L3 18l3 3 4.7-4.7a5 5 0 0 0 6.8-6.8l-3 3-3-3z"/></svg>',
        message: '<svg viewBox="0 0 24 24"><path d="M4 5h16v12H9l-5 4z"/><path d="M8 9h8M8 13h5"/></svg>',
        award: '<svg viewBox="0 0 24 24"><circle cx="12" cy="9" r="6"/><path d="m8.5 14-1 8 4.5-3 4.5 3-1-8M9.5 9l1.5 1.5L14.5 7"/></svg>',
        brain: '<svg viewBox="0 0 24 24"><path d="M9 4a3 3 0 0 0-5 2.2A3.5 3.5 0 0 0 3 13a3.5 3.5 0 0 0 4 5.8A3 3 0 0 0 12 17V6a3 3 0 0 0-3-2ZM15 4a3 3 0 0 1 5 2.2A3.5 3.5 0 0 1 21 13a3.5 3.5 0 0 1-4 5.8A3 3 0 0 1 12 17V6a3 3 0 0 1 3-2Z"/><path d="M7 9h2M15 9h2M7 14h2M15 14h2"/></svg>',
        relationships: '<svg viewBox="0 0 24 24"><circle cx="8" cy="8" r="3"/><circle cx="17" cy="8" r="3"/><path d="M2.5 20a5.5 5.5 0 0 1 11 0M10.5 20a5.5 5.5 0 0 1 11 0"/><path d="m10 12 2 2 2-2"/></svg>',
        focus: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>',
        habit: '<svg viewBox="0 0 24 24"><path d="M20 7v5h-5M4 17v-5h5"/><path d="M6.1 8a7 7 0 0 1 11.8-1L20 12M4 12l2.1 5a7 7 0 0 0 11.8-1"/><path d="m9 12 2 2 4-4"/></svg>',
        bolt: '<svg viewBox="0 0 24 24"><path d="m13 2-8 12h7l-1 8 8-12h-7z"/></svg>',
        moon: '<svg viewBox="0 0 24 24"><path d="M20 15.5A8.5 8.5 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5Z"/><path d="M16.5 5.5h3M18 4v3"/></svg>',
        balance: '<svg viewBox="0 0 24 24"><path d="M12 3v18M5 6h14M8 6l-4 7h8zM16 6l-4 7h8zM7 21h10"/></svg>',
        compass: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5-5 2 2-5z"/></svg>',
        filter: '<svg viewBox="0 0 24 24"><path d="M3 5h18l-7 8v6l-4 2v-8z"/></svg>',
        repeat: '<svg viewBox="0 0 24 24"><path d="M17 3l4 4-4 4M3 7h18M7 21l-4-4 4-4M21 17H3"/></svg>',
        checklist: '<svg viewBox="0 0 24 24"><path d="M9 6h11M9 12h11M9 18h11M3.5 6l1.2 1.2L7 4.8M3.5 12l1.2 1.2L7 10.8M3.5 18l1.2 1.2L7 16.8"/></svg>',
        layers: '<svg viewBox="0 0 24 24"><path d="m12 3 9 5-9 5-9-5zM3 12l9 5 9-5M3 16l9 5 9-5"/></svg>',
        calendar: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18M8 14h3M13 14h3M8 18h3"/></svg>',
        check: '<svg viewBox="0 0 20 20"><path d="m5 10.2 3 3.1 7-7.1"/></svg>',
        star: '<svg viewBox="0 0 24 24"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3Z"/></svg>',
        people: '<svg viewBox="0 0 24 24"><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2.5 20a5.5 5.5 0 0 1 11 0M13.5 20a4.5 4.5 0 0 1 8 0"/></svg>',
        page: '<svg viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6V3ZM14 3v5h5"/></svg>',
        level: '<svg viewBox="0 0 24 24"><path d="M5 19v-5M12 19V9M19 19V4"/></svg>'
      };

      const STORAGE_KEY = 'suityou_skill_finder_v2';
      const STORAGE_SCHEMA = 2;
      const STORAGE_MAX_AGE = 1000 * 60 * 60 * 24 * 180;
      const SCORE_EPSILON = 0.000001;
      const CLOSE_SCORE_THRESHOLD = 1;
      const configuredWorlds = config.worlds || {};

      const normalizeList = (value) => {
        if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
        if (typeof value !== 'string') return [];
        return value.split(',').map((item) => item.trim()).filter(Boolean);
      };

      const normalizeOptionalValue = (value) => value === null || value === undefined
        ? ''
        : String(value).trim();

      const normalizeResource = (resource, index) => ({
        included: resource?.included === true,
        id: String(resource?.id || resource?.handle || `resource-${index}`),
        handle: String(resource?.handle || ''),
        title: String(resource?.title || ''),
        link: String(resource?.url || ''),
        image: String(resource?.image || ''),
        description: String(resource?.description || '').replace(/\uFFFD/g, ''),
        meta: String(resource?.meta || ''),
        rating: normalizeOptionalValue(resource?.rating),
        ratingCount: normalizeOptionalValue(resource?.ratingCount),
        learners: normalizeOptionalValue(resource?.learners),
        pages: normalizeOptionalValue(resource?.pages),
        duration: normalizeOptionalValue(resource?.duration),
        lessons: normalizeOptionalValue(resource?.lessons),
        level: normalizeOptionalValue(resource?.level),
        formats: normalizeList(resource?.formats),
        outcomes: normalizeList(resource?.outcomes),
        levels: normalizeList(resource?.levels),
        actionStyles: normalizeList(resource?.actionStyles),
        timeSuitability: normalizeList(resource?.timeSuitability),
        curatedOrder: index
      });

      const configuredResources = (worldKey) => Array.isArray(configuredWorlds[worldKey]?.resources)
        ? configuredWorlds[worldKey].resources.map(normalizeResource).filter((resource) => resource.title && resource.link)
        : [];

      const configuredCount = (worldKey) => {
        const value = Number(configuredWorlds[worldKey]?.count);
        return Number.isFinite(value) && value > 0 ? value : null;
      };

      const configuredLink = (worldKey, fallback) => String(configuredWorlds[worldKey]?.link || fallback);

      const worlds = {
        money: {
          title: 'Money & Business',
          shortTitle: 'Money & Business',
          description: 'Build income, invest smarter, and create financial freedom.',
          count: configuredCount('money'),
          link: configuredLink('money', '/collections/suityou-money-business'),
          color: '#227E6A',
          bg: '#EAF8F4',
          resources: configuredResources('money')
        },
        creator: {
          title: 'Creator & Marketing',
          shortTitle: 'Creator & Marketing',
          description: 'Build your brand, grow your audience, and make impact.',
          count: configuredCount('creator'),
          link: configuredLink('creator', '/collections/suityou-creator-marketing'),
          color: '#e10e2b',
          bg: '#fdecef',
          resources: configuredResources('creator')
        },
        ai: {
          title: 'AI & Technology',
          shortTitle: 'AI & Technology',
          description: 'Use AI to work smarter, automate, and build skills.',
          count: configuredCount('ai'),
          link: configuredLink('ai', '/collections/suityou-ai-technology'),
          color: '#b50f27',
          bg: '#fff2f4',
          resources: configuredResources('ai')
        },
        confidence: {
          title: 'Confidence & Communication',
          shortTitle: 'Confidence & Communication',
          description: 'Think clearly, speak well, and build unstoppable confidence.',
          count: configuredCount('confidence'),
          link: configuredLink('confidence', '/collections/suityou-confidence-communication'),
          color: '#DE6B34',
          bg: '#FFF1EA',
          resources: configuredResources('confidence')
        },
        life: {
          title: 'Life, Health & Relationships',
          shortTitle: 'Life, Health & Relationships',
          description: 'Improve your health, habits, and relationships.',
          count: configuredCount('life'),
          link: configuredLink('life', '/collections/suityou-life-health-relationships'),
          color: '#0F918F',
          bg: '#E9F9F8',
          resources: configuredResources('life')
        }
      };

      const worldKeys = Object.keys(worlds);
      const state = {
        index: 0,
        answers: {},
        mode: 'question',
        timers: [],
        resultData: null
      };
      const resultStateScript = document.createElement('script');
      resultStateScript.type = 'application/json';
      resultStateScript.setAttribute('data-sy-skill-result-state', '');
      resultStateScript.textContent = '{}';
      skillRoot.appendChild(resultStateScript);

      const questionProgress = [13, 25, 38, 50, 63, 75, 88, 95];
      const stageForIndex = (index) => (index < 3 ? 1 : index < 6 ? 2 : 3);
      const clamp = (number, min, max) => Math.max(min, Math.min(max, number));
      const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char]);
      const escapeAttr = escapeHtml;

      const score = (pairs, fallback = .08) => {
        const out = {};
        worldKeys.forEach((key) => {
          out[key] = fallback;
        });
        Object.entries(pairs).forEach(([key, value]) => {
          out[key] = value;
        });
        return out;
      };

      const balancedScore = (value = .76) => {
        const out = {};
        worldKeys.forEach((key) => {
          out[key] = value;
        });
        return out;
      };

      const formatData = {
        ebooks: { label: 'Ebook', action: 'Explore', icon: icons.book },
        audio: { label: 'Audiobook', action: 'Listen now', icon: icons.audio },
        video: { label: 'Course', action: 'Start course', icon: icons.video },
        tools: { label: 'Template', action: 'Download', icon: icons.tool },
        mix: { label: 'Mixed', action: 'Explore', icon: icons.spark }
      };

      const outcomes = {
        money: [
          { value: 'make-more', label: 'Make more money', helper: 'Find ideas, offers, and income systems.', icon: icons.income, scores: score({ money: 1, creator: .48 }) },
          { value: 'manage-money', label: 'Manage money better', helper: 'Budget, save, plan, and invest smarter.', icon: icons.wallet, scores: score({ money: 1, life: .35 }) },
          { value: 'start-business', label: 'Start a business', helper: 'Turn skills into something people buy.', icon: icons.launch, scores: score({ money: .92, creator: .7, ai: .45 }) },
          { value: 'improve-sales', label: 'Improve sales', helper: 'Make your offer clearer and easier to sell.', icon: icons.sales, scores: score({ money: .85, creator: .75 }) },
          { value: 'build-wealth', label: 'Build long-term wealth', helper: 'Create a stable plan you can follow.', icon: icons.invest, scores: score({ money: 1, confidence: .34 }) }
        ],
        creator: [
          { value: 'grow-audience', label: 'Grow an audience', helper: 'Get better at content and visibility.', icon: icons.audience, scores: score({ creator: 1, confidence: .42 }) },
          { value: 'build-brand', label: 'Build my brand', helper: 'Make your message feel clear and trusted.', icon: icons.brand, scores: score({ creator: 1, confidence: .5 }) },
          { value: 'create-content', label: 'Create better content', helper: 'Plan, publish, and improve consistently.', icon: icons.content, scores: score({ creator: .95, ai: .45 }) },
          { value: 'sell-offers', label: 'Sell offers', helper: 'Turn attention into a practical offer.', icon: icons.tag, scores: score({ creator: .9, money: .72 }) },
          { value: 'monetize-skills', label: 'Monetize my skills', helper: 'Package what you know into income.', icon: icons.income, scores: score({ creator: .9, money: .82 }) }
        ],
        ai: [
          { value: 'use-ai', label: 'Use AI better', helper: 'Apply tools without getting lost.', icon: icons.ai, scores: score({ ai: 1, creator: .35 }) },
          { value: 'automate-work', label: 'Automate work', helper: 'Save time with repeatable systems.', icon: icons.automation, scores: score({ ai: 1, money: .55 }) },
          { value: 'build-skills', label: 'Build tech skills', helper: 'Learn the tools that matter now.', icon: icons.code, scores: score({ ai: .96, confidence: .3 }) },
          { value: 'speed-up-business', label: 'Speed up business', helper: 'Use systems to move faster.', icon: icons.rocket, scores: score({ ai: .86, money: .72, creator: .48 }) },
          { value: 'learn-tools', label: 'Learn practical tools', helper: 'Start with direct, usable workflows.', icon: icons.wrench, scores: score({ ai: .96, life: .34 }) }
        ],
        confidence: [
          { value: 'speak-better', label: 'Speak better', helper: 'Communicate with more clarity.', icon: icons.message, scores: score({ confidence: 1, creator: .4 }) },
          { value: 'build-confidence', label: 'Build confidence', helper: 'Stop second-guessing your next move.', icon: icons.award, scores: score({ confidence: 1, life: .38 }) },
          { value: 'think-clearly', label: 'Think clearly', helper: 'Make decisions with less noise.', icon: icons.brain, scores: score({ confidence: .95, money: .35 }) },
          { value: 'handle-relationships', label: 'Handle relationships', helper: 'Improve boundaries and conversations.', icon: icons.relationships, scores: score({ confidence: .82, life: .78 }) },
          { value: 'stay-focused', label: 'Stay focused', helper: 'Build discipline around what matters.', icon: icons.focus, scores: score({ confidence: .84, life: .62, ai: .35 }) }
        ],
        life: [
          { value: 'better-habits', label: 'Build better habits', helper: 'Create routines that actually stick.', icon: icons.habit, scores: score({ life: 1, confidence: .48 }) },
          { value: 'more-energy', label: 'Have more energy', helper: 'Improve the inputs that drive your day.', icon: icons.bolt, scores: score({ life: 1, confidence: .34 }) },
          { value: 'sleep-better', label: 'Sleep better', helper: 'Reset rest, focus, and recovery.', icon: icons.moon, scores: score({ life: 1, ai: .25 }) },
          { value: 'better-relationships', label: 'Improve relationships', helper: 'Communicate and connect with less friction.', icon: icons.relationships, scores: score({ life: .88, confidence: .82 }) },
          { value: 'balance-life', label: 'Feel more balanced', helper: 'Make life feel organized again.', icon: icons.balance, scores: score({ life: .94, confidence: .58 }) }
        ]
      };

      const questions = [
        {
          id: 'world',
          weight: 25,
          reasonLabel: 'Starting direction',
          title: 'What do you want to improve most right now?',
          help: 'Choose the world that feels closest to your current goal.',
          grid: 'is-world-grid',
          options: () => worldKeys.map((key) => ({
            value: key,
            label: worlds[key].shortTitle,
            helper: worlds[key].description,
            icon: icons[key],
            color: worlds[key].color,
            bg: worlds[key].bg,
            scores: score({ [key]: 1 }, .02)
          }))
        },
        {
          id: 'outcome',
          weight: 40,
          reasonLabel: 'Desired outcome',
          title: 'What result matters most to you?',
          help: 'This helps us separate broad curiosity from the exact result you want.',
          options: (answers = state.answers) => outcomes[answers.world || 'money']
        },
        {
          id: 'level',
          weight: 0,
          title: 'Where would you say you are right now?',
          help: 'We will prioritize resources that fit your current level.',
          options: () => [
            { value: 'starting', label: 'Just starting', helper: 'I need the clearest overview first.', icon: icons.compass, scores: balancedScore(.72) },
            { value: 'basic', label: 'I know the basics', helper: 'I want structure and better next steps.', icon: icons.book, scores: balancedScore(.8) },
            { value: 'experienced', label: 'Some experience', helper: 'I want sharper systems and examples.', icon: icons.sales, scores: balancedScore(.86) },
            { value: 'advanced', label: 'Experienced, better results', helper: 'I want advanced tools and execution.', icon: icons.award, scores: balancedScore(.84) }
          ]
        },
        {
          id: 'obstacle',
          weight: 20,
          reasonLabel: 'Main obstacle',
          title: 'What is your biggest obstacle right now?',
          help: 'The old finder focused on removing friction first, so we kept that logic here.',
          options: () => [
            { value: 'start', label: 'I do not know where to start', helper: 'Give me the first clear step.', icon: icons.compass, scores: balancedScore(.78) },
            { value: 'too-much', label: 'Too much information', helper: 'Help me filter what matters.', icon: icons.filter, scores: score({ ai: .82, confidence: .78, money: .72, creator: .72, life: .72 }) },
            { value: 'consistency', label: 'I struggle to stay consistent', helper: 'Give me a track I can follow.', icon: icons.repeat, scores: score({ confidence: .88, life: .85, money: .72, creator: .72, ai: .72 }) },
            { value: 'steps', label: 'I need practical steps', helper: 'Show me exactly what to do next.', icon: icons.checklist, scores: balancedScore(.86) },
            { value: 'systems', label: 'I need better tools or systems', helper: 'Help me organize and execute.', icon: icons.automation, scores: score({ ai: .92, money: .78, creator: .76, confidence: .66, life: .68 }) }
          ]
        },
        {
          id: 'format',
          weight: 0,
          title: 'How do you prefer to learn?',
          help: 'This reuses the old finder formats and adds a mixed option.',
          grid: 'is-compact-grid',
          options: () => [
            { value: 'ebooks', label: 'Ebooks & Guides', helper: 'Structured reading with depth.', icon: icons.book, scores: balancedScore(.84) },
            { value: 'audio', label: 'Audiobooks', helper: 'Learn while moving.', icon: icons.audio, scores: balancedScore(.82) },
            { value: 'video', label: 'Video Courses', helper: 'Watch the system first.', icon: icons.video, scores: balancedScore(.84) },
            { value: 'tools', label: 'Templates & Tools', helper: 'Use checklists, trackers, and templates.', icon: icons.tool, scores: score({ ai: .88, money: .84, creator: .84, confidence: .76, life: .78 }) },
            { value: 'mix', label: 'A mix of everything', helper: 'Give me the best resource for the job.', icon: icons.layers, scores: balancedScore(.88) }
          ]
        },
        {
          id: 'time',
          weight: 0,
          title: 'How much time do you realistically want to spend learning?',
          help: 'Shorter time windows prioritize direct resources first.',
          grid: 'is-compact-grid',
          options: () => [
            { value: 'short', label: '10-15 minutes at a time', helper: 'Quick, focused lessons.', icon: icons.clock, scores: balancedScore(.76) },
            { value: 'medium', label: '20-30 minutes', helper: 'Enough time to learn and apply.', icon: icons.clock, scores: balancedScore(.84) },
            { value: 'long', label: 'Around an hour', helper: 'I can go deeper.', icon: icons.book, scores: balancedScore(.88) },
            { value: 'flexible', label: 'I am flexible', helper: 'Match me to the best path.', icon: icons.calendar, scores: balancedScore(.86) }
          ]
        },
        {
          id: 'style',
          weight: 15,
          reasonLabel: 'Action style',
          title: 'What type of learning helps you take action?',
          help: 'This determines whether we lead with lessons, examples, or tools.',
          options: () => [
            { value: 'step-by-step', label: 'Short step-by-step lessons', helper: 'Clear actions in the right order.', icon: icons.checklist, scores: balancedScore(.86) },
            { value: 'deep', label: 'Deep explanations', helper: 'I want to understand the why.', icon: icons.book, scores: score({ money: .86, confidence: .86, life: .82, ai: .78, creator: .78 }) },
            { value: 'examples', label: 'Examples and case studies', helper: 'Show me how it works in real life.', icon: icons.audience, scores: score({ creator: .86, money: .84, ai: .84, confidence: .78, life: .72 }) },
            { value: 'checklists', label: 'Checklists and templates', helper: 'Give me something I can use.', icon: icons.tool, scores: score({ ai: .9, money: .84, creator: .84, confidence: .74, life: .76 }) },
            { value: 'combination', label: 'A combination', helper: 'I want the most complete path.', icon: icons.layers, scores: balancedScore(.9) }
          ]
        },
        {
          id: 'timeframe',
          weight: 0,
          title: 'How soon do you want to start applying what you learn?',
          help: 'Your answer helps us keep the path practical.',
          grid: 'is-compact-grid',
          options: () => [
            { value: 'today', label: 'Today', helper: 'Give me something I can open now.', icon: icons.bolt, scores: balancedScore(.9) },
            { value: 'week', label: 'This week', helper: 'I want a focused plan.', icon: icons.calendar, scores: balancedScore(.86) },
            { value: 'month', label: 'This month', helper: 'I want to build steadily.', icon: icons.clock, scores: balancedScore(.82) },
            { value: 'exploring', label: 'I am exploring for now', helper: 'Help me discover the right direction.', icon: icons.compass, scores: balancedScore(.76) }
          ]
        }
      ];

      const questionOptions = (question, answers = state.answers) => question.options(answers);
      const optionForAnswer = (question, answers = state.answers) => questionOptions(question, answers)
        .find((option) => option.value === answers[question.id]);

      const validateAnswers = (candidate) => {
        const valid = {};
        if (!candidate || typeof candidate !== 'object') return valid;

        questions.forEach((question) => {
          if (question.id === 'outcome' && !valid.world) return;
          const selected = candidate[question.id];
          if (questionOptions(question, valid).some((option) => option.value === selected)) {
            valid[question.id] = selected;
          }
        });
        return valid;
      };

      const loadStoredState = () => {
        try {
          const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
          if (!parsed || parsed.schema !== STORAGE_SCHEMA || !Number.isFinite(parsed.timestamp)) return null;
          if (Date.now() - parsed.timestamp > STORAGE_MAX_AGE) {
            window.localStorage.removeItem(STORAGE_KEY);
            return null;
          }

          const answers = validateAnswers(parsed.answers);
          const completed = parsed.completed === true && questions.every((question) => Boolean(answers[question.id]));
          const requestedQuestion = clamp(Number(parsed.currentQuestion) || 0, 0, questions.length - 1);
          const firstMissingQuestion = questions.findIndex((question) => !answers[question.id]);
          return {
            answers,
            completed,
            currentQuestion: firstMissingQuestion >= 0 && requestedQuestion > firstMissingQuestion
              ? firstMissingQuestion
              : requestedQuestion
          };
        } catch (error) {
          return null;
        }
      };

      const saveStoredState = () => {
        try {
          const completed = state.mode === 'result' && Boolean(state.resultData);
          const resultInputs = completed ? {
            worldKey: state.resultData.worldKey,
            confidence: state.resultData.matchScore,
            resourceIds: state.resultData.resources.map((resource) => resource.id),
            reasonAnswerIds: state.resultData.reasons.map((reason) => reason.answerId)
          } : null;
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
            schema: STORAGE_SCHEMA,
            timestamp: Date.now(),
            currentQuestion: state.index,
            answers: state.answers,
            completed,
            resultInputs
          }));
        } catch (error) {
          // Storage can be unavailable in private or restricted browser contexts.
        }
      };

      const clearStoredState = () => {
        try {
          window.localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
          // Keep the finder usable even if storage access is blocked.
        }
      };

      const publishResultState = () => {
        const result = state.resultData;
        resultStateScript.textContent = JSON.stringify(result ? {
          mode: state.mode,
          worldKey: result.worldKey,
          matchScore: result.matchScore,
          scores: result.scores,
          reasons: result.reasons,
          confidence: result.confidence,
          tieBreak: result.tieBreak,
          resources: result.resources.map((resource) => ({
            id: resource.id,
            recommendationScore: resource.recommendationScore,
            scoreBreakdown: resource.scoreBreakdown
          }))
        } : { mode: state.mode });
      };

      const invalidateResult = () => {
        state.resultData = null;
        if (state.mode === 'result') state.mode = 'question';
        publishResultState();
      };

      const restoredState = loadStoredState();
      if (restoredState) {
        state.answers = restoredState.answers;
        state.index = restoredState.currentQuestion;
        state.mode = restoredState.completed ? 'result' : 'question';
      }

      const clearTimers = () => {
        state.timers.forEach((timer) => window.clearTimeout(timer));
        state.timers = [];
      };

      const setStatus = (message) => {
        if (status) status.textContent = message;
      };

      const setProgress = (value, label) => {
        const nextValue = clamp(Math.round(value), 0, 100);
        progress.setAttribute('aria-valuenow', String(nextValue));
        progressFill.style.width = `${nextValue}%`;
        progressText.textContent = `${label} · ${nextValue}%`;
      };

      const updateStages = () => {
        const activeStage = state.mode === 'result' ? 3 : stageForIndex(state.index);
        stages.forEach((stage) => {
          const number = Number(stage.dataset.sySkillStage);
          stage.classList.toggle('is-active', number === activeStage);
          stage.classList.toggle('is-complete', number < activeStage || state.mode === 'result');
        });
      };

      const scrollSkillCardIntoView = (includeHeading = false) => {
        if (!mobileSkillView.matches || !card) return;
        const behavior = reducedMotion.matches ? 'auto' : 'smooth';
        const target = includeHeading ? skillRoot : card;
        const header = document.querySelector('.shopify-section-header, .header-wrapper, sticky-header, header');
        const headerStyle = header ? window.getComputedStyle(header) : null;
        const headerRect = header ? header.getBoundingClientRect() : null;
        const headerIsPinned = headerStyle && ['sticky', 'fixed'].includes(headerStyle.position) && headerRect && headerRect.bottom > 0;
        const headerHeight = headerRect && headerRect.height > 0 ? headerRect.height : 68;
        const offset = Math.max(headerIsPinned ? headerHeight : 0, headerHeight, 68) + 14;
        const scrollToCard = () => {
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, top), behavior });
        };

        window.requestAnimationFrame(() => {
          scrollToCard();
          window.setTimeout(scrollToCard, reducedMotion.matches ? 0 : 260);
        });
      };

      const currentQuestion = () => questions[state.index];
      const currentAnswer = () => {
        const question = currentQuestion();
        const value = state.answers[question.id];
        return questionOptions(question).some((option) => option.value === value) ? value : null;
      };

      const updateControls = () => {
        const isQuestion = state.mode === 'question';
        if (controlsRow) controlsRow.hidden = !isQuestion;
        if (!isQuestion) return;

        const answered = Boolean(currentAnswer());
        backButton.disabled = state.index === 0;
        nextButton.disabled = !answered;
        nextButton.textContent = state.index === questions.length - 1 ? 'Find My Best Path' : 'Next';
        setStatus(answered ? 'Answer saved. Continue when you are ready.' : 'Choose one answer to continue.');
      };

      const optionClass = (option) => {
        const worldClass = worlds[option.value] ? ` sy-home-one__skill-option--${option.value}` : '';
        return `sy-home-one__skill-option${worldClass}`;
      };

      const optionStyle = (option) => {
        const color = option.color || 'var(--sy-one-purple)';
        const bg = option.bg || '#fff2f4';
        return `--skill-color:${color};--skill-bg:${bg};`;
      };

      const renderQuestion = (direction = 'next') => {
        clearTimers();
        state.mode = 'question';
        publishResultState();
        const question = currentQuestion();
        const answered = currentAnswer();
        const options = questionOptions(question);
        const progressValue = questionProgress[state.index];

        skillRoot.classList.remove('is-analyzing', 'is-result');
        setProgress(progressValue, `Question ${state.index + 1} of ${questions.length}`);
        if (progressTitle) progressTitle.textContent = 'Answer a few questions to get your personalized path';
        updateStages();

        const panelClass = direction === 'back' ? ' is-transitioning-in' : '';
        const optionsHtml = options.map((option) => {
          const isSelected = answered === option.value;
          const icon = option.icon || icons.spark;
          const image = question.id === 'world' ? configuredWorlds[option.value]?.image : '';
          const visual = image
            ? `<span class="sy-home-one__skill-option-image" aria-hidden="true"><img src="${escapeAttr(image)}" alt="" width="112" height="112" decoding="async"></span>`
            : `<span class="sy-home-one__skill-option-icon" aria-hidden="true">${icon}</span>`;
          return `
            <button class="${optionClass(option)}${isSelected ? ' is-selected' : ''}" type="button" role="radio" aria-checked="${isSelected ? 'true' : 'false'}" data-sy-answer="${escapeAttr(option.value)}" style="${optionStyle(option)}">
              ${visual}
              <span class="sy-home-one__skill-option-copy">
                <strong>${escapeHtml(option.label)}</strong>
                <small>${escapeHtml(option.helper || '')}</small>
              </span>
              <span class="sy-home-one__skill-check" aria-hidden="true">${icons.check}</span>
            </button>
          `;
        }).join('');

        screen.innerHTML = `
          <div class="sy-home-one__skill-panel${panelClass}" data-sy-skill-panel>
            <p class="sy-home-one__skill-question-kicker"><span>${String(state.index + 1).padStart(2, '0')}</span>Question ${state.index + 1} of ${questions.length}</p>
            <h3 class="sy-home-one__skill-question-title">${escapeHtml(question.title)}</h3>
            <p class="sy-home-one__skill-question-help">${escapeHtml(question.help)}</p>
            <div class="sy-home-one__skill-options sy-home-one__skill-options--quiz ${question.grid || ''}" role="radiogroup" aria-label="${escapeAttr(question.title)}">
              ${optionsHtml}
            </div>
          </div>
        `;

        screen.querySelectorAll('[data-sy-answer]').forEach((button) => {
          button.addEventListener('click', () => {
            const previousAnswer = state.answers[question.id];
            const nextAnswer = button.dataset.syAnswer;
            state.answers[question.id] = nextAnswer;
            if (previousAnswer !== nextAnswer) {
              if (question.id === 'world') delete state.answers.outcome;
              invalidateResult();
              saveStoredState();
            }
            screen.querySelectorAll('[data-sy-answer]').forEach((optionButton) => {
              const isSelected = optionButton === button;
              optionButton.classList.toggle('is-selected', isSelected);
              optionButton.setAttribute('aria-checked', isSelected ? 'true' : 'false');
            });
            updateControls();
          });
        });

        updateControls();
      };

      const optionByAnswer = (question) => optionForAnswer(question);

      const worldSignalQuestions = questions.filter((question) => question.weight > 0);
      const tieQuestionIds = ['outcome', 'obstacle', 'world', 'style'];

      const selectedSignal = (question) => {
        const option = optionByAnswer(question);
        if (!option) return null;
        const affinities = {};
        worldKeys.forEach((key) => {
          affinities[key] = Number(option.scores?.[key]) || 0;
        });
        const values = Object.values(affinities);
        const maximum = Math.max(...values);
        const minimum = Math.min(...values);
        if (maximum - minimum <= SCORE_EPSILON) return null;
        return { question, option, affinities, maximum };
      };

      const compareCloseWorlds = (leftKey, rightKey, signals) => {
        for (const questionId of tieQuestionIds) {
          const signal = signals.find((item) => item.question.id === questionId);
          if (!signal) continue;
          const difference = signal.affinities[rightKey] - signal.affinities[leftKey];
          if (Math.abs(difference) > SCORE_EPSILON) return difference;
        }
        return worldKeys.indexOf(leftKey) - worldKeys.indexOf(rightKey);
      };

      const scoreResourceDimension = (configuredValues, selectedValue, points) => (
        selectedValue && configuredValues.includes(selectedValue) ? points : 0
      );

      const selectResources = (worldKey) => {
        const world = worlds[worldKey] || worlds.money;
        const selected = {
          outcome: state.answers.outcome || '',
          format: state.answers.format || '',
          level: state.answers.level || '',
          style: state.answers.style || '',
          time: state.answers.time || ''
        };

        return world.resources
          .map((resource) => {
            const breakdown = {
              outcome: scoreResourceDimension(resource.outcomes, selected.outcome, 40),
              format: scoreResourceDimension(resource.formats, selected.format, 25),
              level: scoreResourceDimension(resource.levels, selected.level, 15),
              actionStyle: scoreResourceDimension(resource.actionStyles, selected.style, 10),
              time: scoreResourceDimension(resource.timeSuitability, selected.time, 10)
            };
            const recommendationScore = Object.values(breakdown).reduce((total, value) => total + value, 0);
            return { ...resource, recommendationScore, scoreBreakdown: breakdown };
          })
          .sort((left, right) => right.recommendationScore - left.recommendationScore || left.curatedOrder - right.curatedOrder)
          .slice(0, 3);
      };

      const calculateResult = () => {
        const scores = Object.fromEntries(worldKeys.map((key) => [key, 0]));
        const signals = worldSignalQuestions.map(selectedSignal).filter(Boolean);
        let maximumAvailable = 0;

        signals.forEach((signal) => {
          maximumAvailable += signal.maximum * signal.question.weight;
          worldKeys.forEach((key) => {
            scores[key] += signal.affinities[key] * signal.question.weight;
          });
        });

        const rankedByScore = worldKeys
          .map((key) => ({ key, score: scores[key] }))
          .sort((left, right) => right.score - left.score || worldKeys.indexOf(left.key) - worldKeys.indexOf(right.key));
        const topScore = rankedByScore[0]?.score || 0;
        const closeContenders = rankedByScore
          .filter((entry) => topScore - entry.score <= CLOSE_SCORE_THRESHOLD + SCORE_EPSILON)
          .map((entry) => entry.key)
          .sort((leftKey, rightKey) => compareCloseWorlds(leftKey, rightKey, signals));
        const winnerKey = closeContenders[0] || rankedByScore[0]?.key || worldKeys[0];
        const winnerScore = scores[winnerKey] || 0;
        const secondPlaceScore = Math.max(0, ...worldKeys.filter((key) => key !== winnerKey).map((key) => scores[key] || 0));
        const winnerSupport = clamp(maximumAvailable > 0 ? winnerScore / maximumAvailable : 0, 0, 1);
        const separation = clamp((winnerScore - secondPlaceScore) / Math.max(winnerScore, 1), 0, 1);
        const agreementCount = signals.filter((signal) => Math.abs(signal.affinities[winnerKey] - signal.maximum) <= SCORE_EPSILON).length;
        const agreement = signals.length ? agreementCount / signals.length : 0;
        const matchScore = clamp(Math.round(78 + winnerSupport * 10 + separation * 6 + agreement * 4), 80, 98);
        const reasons = tieQuestionIds
          .map((questionId) => signals.find((signal) => signal.question.id === questionId))
          .filter((signal) => signal && Math.abs(signal.affinities[winnerKey] - signal.maximum) <= SCORE_EPSILON)
          .map((signal) => ({
            signal: signal.question.id,
            label: signal.question.reasonLabel,
            answerId: signal.option.value,
            answerLabel: signal.option.label,
            detail: signal.option.helper,
            weight: signal.question.weight
          }));

        return {
          worldKey: winnerKey,
          world: worlds[winnerKey],
          matchScore,
          resources: selectResources(winnerKey),
          scores: rankedByScore,
          reasons,
          confidence: { winnerSupport, separation, agreement, discriminatingAnswers: signals.length },
          tieBreak: { threshold: CLOSE_SCORE_THRESHOLD, contenders: closeContenders, hierarchy: tieQuestionIds }
        };
      };

      const resourceFormat = (resource) => {
        const preferredFormat = state.answers.format || 'ebooks';
        if (preferredFormat !== 'mix' && resource.formats.includes(preferredFormat)) return formatData[preferredFormat];
        const first = resource.formats[0] || 'ebooks';
        return formatData[first] || formatData.ebooks;
      };

      const resourceValueWithUnit = (value, unit) => /[a-z]/i.test(value) ? value : `${value} ${unit}`;

      const resourceLevelLabel = (value) => value
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());

      const resourceDescription = (value) => {
        let description = String(value || '')
          .replace(/\uFFFD/g, '')
          .replace(/\.{3,}\s*$/, '')
          .replace(/\s+/g, ' ')
          .trim();

        if (!description) return '';

        description = description
          .replace(/^In this (?:ebook|e-book|guide|workbook|checklist|course|resource),\s*(?:you|your customers|readers)\s+(?:will|can)\s+learn how to\s+/i, 'Learn how to ')
          .replace(/^In this (?:ebook|e-book|guide|workbook|checklist|course|resource),\s*(?:you(?:'|\u2019)?ll|you will|your customers will|readers will)\s+discover\s+/i, 'Discover ')
          .replace(/^You(?:'|\u2019)?ll discover\s+/i, 'Discover ')
          .replace(/^You will learn how to\s+/i, 'Learn how to ');

        const firstSentence = (description.match(/^.*?[.!?](?=\s|$)/) || [description])[0].trim();
        if (firstSentence.length <= 88) {
          return /[.!?]$/.test(firstSentence) ? firstSentence : `${firstSentence}.`;
        }

        const excerpt = firstSentence.slice(0, 89);
        const punctuationBreak = Math.max(
          excerpt.lastIndexOf(','),
          excerpt.lastIndexOf(';'),
          excerpt.lastIndexOf(':')
        );
        const wordBreak = excerpt.lastIndexOf(' ');
        const breakAt = punctuationBreak >= 52 ? punctuationBreak : wordBreak;
        let sentence = excerpt
          .slice(0, breakAt > 0 ? breakAt : 88)
          .replace(/\s+(?:and|or|with|using|through|by|for|to|into|from|as)$/i, '')
          .replace(/[,:;\s-]+$/, '')
          .trim();

        const danglingConnector = [...sentence.matchAll(/\s+(?:and|or|with|using|through|by|for|to|into|from|as)\s+/gi)]
          .filter((match) => match.index >= 52)
          .pop();
        if (danglingConnector) sentence = sentence.slice(0, danglingConnector.index).trim();

        return sentence ? `${sentence}.` : '';
      };

      const resourceStats = (resource) => {
        const stats = [];
        if (resource.rating) {
          stats.push({ icon: icons.star, label: resource.ratingCount ? `${resource.rating} (${resource.ratingCount})` : resource.rating });
        }
        if (resource.learners) {
          stats.push({ icon: icons.people, label: resourceValueWithUnit(resource.learners, 'learners') });
        }

        const prefersLessons = resource.formats.includes('video');
        if (prefersLessons && resource.lessons) {
          stats.push({ icon: icons.video, label: resourceValueWithUnit(resource.lessons, 'lessons') });
        } else if (resource.pages) {
          stats.push({ icon: icons.page, label: resourceValueWithUnit(resource.pages, 'pages') });
        } else if (resource.lessons) {
          stats.push({ icon: icons.video, label: resourceValueWithUnit(resource.lessons, 'lessons') });
        } else if (resource.meta) {
          stats.push({ icon: icons.page, label: resource.meta });
        }

        if (resource.duration) {
          stats.push({ icon: icons.clock, label: resource.duration });
        }
        if (resource.level) {
          stats.push({ icon: icons.level, label: resourceLevelLabel(resource.level) });
        }

        if (!stats.length) return '';
        return `<span class="sy-home-one__skill-resource-stats" aria-label="Resource details">${stats.slice(0, 5).map((stat) => `
          <span class="sy-home-one__skill-resource-stat">${stat.icon}<span>${escapeHtml(stat.label)}</span></span>
        `).join('')}</span>`;
      };

      const resourceCard = (resource, world) => {
        const format = resourceFormat(resource);
        const resourceLink = resource.link || world.link || fallbackLink;
        const displayTitle = resource.title.replace(/\s+-\s+Ebook$/i, '');
        const imageHtml = resource.image
          ? `<img class="sy-home-one__skill-resource-image" src="${escapeAttr(resource.image)}" alt="${escapeAttr(resource.title)} cover" loading="lazy" width="960" height="960">`
          : '';
        const description = resourceDescription(resource.description);
        const descriptionHtml = description
          ? `<p class="sy-home-one__skill-resource-description">${escapeHtml(description)}</p>`
          : '';
        const statsHtml = resourceStats(resource);
        return `
          <a class="sy-home-one__skill-resource" href="${escapeAttr(resourceLink)}">
            <span class="sy-home-one__skill-resource-media">${imageHtml}</span>
            <div class="sy-home-one__skill-resource-copy">
              <span class="sy-home-one__skill-resource-type">${format.icon}${escapeHtml(format.label)}</span>
              ${document.body.dataset.member === 'true' ? `<span class="sy-member-badge${resource.included ? '' : ' sy-member-badge--locked'}">${resource.included ? 'Included' : 'Locked · Preview available'}</span>` : ''}
              <strong>${escapeHtml(displayTitle)}</strong>
              ${descriptionHtml}
              ${statsHtml}
            </div>
          </a>
        `;
      };

      const checklistCheck = '<span class="sy-home-one__skill-check-icon" aria-hidden="true">✓<svg viewBox="0 0 24 24"><path d="m5 12 4 4L19 6"></path></svg></span>';

      const resultHtml = (data) => {
        const countItem = data.world.count
          ? `<li>${checklistCheck}Curated from ${escapeHtml(data.world.count.toLocaleString())} resources</li>`
          : '';
        return `
        <div class="sy-home-one__skill-result-view">
          <div class="sy-home-one__skill-result-main">
            <span class="sy-home-one__skill-result-badge">Your suggested starting point</span>
            <div class="sy-home-one__skill-result-summary">
              <div class="sy-home-one__skill-result-top">
                <span class="sy-home-one__skill-result-icon" style="--skill-color:${data.world.color};--skill-bg:${data.world.bg};" aria-hidden="true">${icons[data.worldKey]}</span>
                <div>
                  <h3>${escapeHtml(data.world.title)} <em>Best Match</em></h3>
                  <p class="sy-home-one__skill-result-copy">${escapeHtml(data.world.description)}</p>
                </div>
              </div>
              <div class="sy-home-one__skill-result-panel">
                <div class="sy-home-one__skill-ring" aria-label="${data.matchScore}% match">
                  <svg viewBox="0 0 120 120" aria-hidden="true">
                    <defs>
                      <linearGradient id="${ringGradientId}" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#d71932"/>
                        <stop offset="100%" stop-color="#b50f27"/>
                      </linearGradient>
                    </defs>
                    <circle cx="60" cy="60" r="48"></circle>
                    <circle cx="60" cy="60" r="48" pathLength="100" style="stroke:url(#${ringGradientId})" data-sy-skill-match-ring></circle>
                  </svg>
                  <strong><span data-sy-skill-score>0</span>%</strong>
                  <span>Match</span>
                </div>
                <ul class="sy-home-one__skill-checklist">
                  <li>${checklistCheck}Personalized for your goals</li>
                  ${countItem}
                  <li>${checklistCheck}Practical &amp; actionable</li>
                  <li>${checklistCheck}${state.answers.level === 'advanced' ? 'Advanced friendly' : 'Beginner friendly'}</li>
                </ul>
              </div>
            </div>
            <p class="sy-home-one__skill-resource-heading">Top resources to get you started:</p>
            <div class="sy-home-one__skill-resource-list">${data.resources.map((resource) => resourceCard(resource, data.world)).join('')}</div>
          </div>
          <div class="sy-home-one__skill-result-actions">
            <a class="sy-home-one__button sy-home-one__button--primary" href="${escapeAttr(data.world.link || fallbackLink)}">${document.body.dataset.member === 'true' ? document.body.dataset[`access${data.worldKey[0].toUpperCase()}${data.worldKey.slice(1)}`] === 'true' ? 'Explore My Path' : 'Preview This World' : 'Explore My Path'}</a>
            ${document.body.dataset.member === 'true' ? '<a href="/pages/membership?view=suityou-library">My SY Learning Platform</a>' : ''}
            <button type="button" data-sy-change-answers>Change Answers</button>
          </div>
        </div>
      `;
      };

      const animateMatchRing = (target) => {
        const ring = screen.querySelector('[data-sy-skill-match-ring]');
        const scoreText = screen.querySelector('[data-sy-skill-score]');
        if (!ring || !scoreText) return;

        const setValue = (value) => {
          const rounded = Math.round(value);
          scoreText.textContent = String(rounded);
          ring.style.strokeDashoffset = String(100 - rounded);
        };

        if (reducedMotion.matches) {
          setValue(target);
          return;
        }

        const start = performance.now();
        const duration = 980;
        const tick = (now) => {
          const elapsed = clamp((now - start) / duration, 0, 1);
          const eased = 1 - Math.pow(1 - elapsed, 3);
          setValue(target * eased);
          if (elapsed < 1) window.requestAnimationFrame(tick);
        };
        window.requestAnimationFrame(tick);
      };

      const renderResult = () => {
        state.mode = 'result';
        skillRoot.classList.remove('is-analyzing');
        skillRoot.classList.add('is-result');
        if (progressTitle) progressTitle.textContent = 'Your path is ready';
        setProgress(100, 'Complete');
        updateStages();
        if (controlsRow) controlsRow.hidden = true;
        screen.innerHTML = resultHtml(state.resultData);
        setStatus('Your path is ready.');
        publishResultState();
        saveStoredState();
        screen.querySelector('[data-sy-change-answers]')?.addEventListener('click', () => {
          state.mode = 'question';
          state.index = 0;
          invalidateResult();
          saveStoredState();
          renderQuestion('back');
          scrollSkillCardIntoView();
        });
        animateMatchRing(state.resultData.matchScore);
      };

      const renderAnalysis = () => {
        state.mode = 'analysis';
        state.resultData = calculateResult();
        publishResultState();
        saveStoredState();
        skillRoot.classList.add('is-analyzing');
        skillRoot.classList.remove('is-result');
        if (controlsRow) controlsRow.hidden = true;
        if (progressTitle) progressTitle.textContent = 'Building your personalized path';
        updateStages();
        setStatus('Analyzing your goals...');
        setProgress(95, 'Analyzing');
        screen.innerHTML = `
          <div class="sy-home-one__skill-analysis" data-sy-skill-analysis>
            <span class="sy-home-one__skill-analysis-orb" aria-hidden="true">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"></circle><path d="M12 4a8 8 0 0 1 8 8"></path></svg>
            </span>
            <h3 data-sy-analysis-title>Analyzing your goals...</h3>
            <p data-sy-analysis-copy>Reading your answers and matching them to the most useful SY Learning Platform world.</p>
            <span class="sy-home-one__skill-analysis-track" aria-hidden="true"><span data-sy-analysis-progress></span></span>
            <span class="sy-home-one__skill-analysis-status" aria-hidden="true">Analyzing &middot; <strong><span data-sy-analysis-percent>95</span>%</strong></span>
          </div>
        `;

        const title = screen.querySelector('[data-sy-analysis-title]');
        const copy = screen.querySelector('[data-sy-analysis-copy]');
        const analysisProgress = screen.querySelector('[data-sy-analysis-progress]');
        const analysisPercent = screen.querySelector('[data-sy-analysis-percent]');
        const steps = [
          { delay: 500, progress: 96, stageProgress: 28, title: 'Matching your learning style...', copy: 'Checking your format, pace, and current level.' },
          { delay: 1300, progress: 98, stageProgress: 50, title: 'Comparing the best resources...', copy: 'Prioritizing resources that fit your goal and obstacle.' },
          { delay: 2200, progress: 99, stageProgress: 74, title: 'Selecting your strongest starting point...', copy: 'Building a focused path you can act on right away.' },
          { delay: 3000, progress: 100, stageProgress: 92, title: 'Your path is ready.', copy: 'Your personalized recommendation is ready to explore.' },
          { delay: 3700, done: true }
        ];

        steps.forEach((step) => {
          const timer = window.setTimeout(() => {
            if (step.done) {
              renderResult();
              return;
            }
            if (title) title.textContent = step.title;
            if (copy) copy.textContent = step.copy;
            if (analysisProgress) analysisProgress.style.width = `${step.stageProgress}%`;
            if (analysisPercent) analysisPercent.textContent = String(step.progress);
            setStatus(step.title);
            setProgress(step.progress, step.progress === 100 ? 'Complete' : 'Analyzing');
          }, reducedMotion.matches ? 0 : step.delay);
          state.timers.push(timer);
        });
      };

      nextButton.addEventListener('click', () => {
        if (state.mode !== 'question' || !currentAnswer()) return;
        const panel = screen.querySelector('[data-sy-skill-panel]');
        panel?.classList.add('is-transitioning-out');

        const moveNext = () => {
          if (state.index >= questions.length - 1) {
            renderAnalysis();
            scrollSkillCardIntoView(true);
            return;
          }
          state.index += 1;
          saveStoredState();
          renderQuestion('next');
          scrollSkillCardIntoView();
        };

        if (reducedMotion.matches) {
          moveNext();
        } else {
          window.setTimeout(moveNext, 180);
        }
      });

      backButton.addEventListener('click', () => {
        if (state.mode !== 'question' || state.index === 0) return;
        state.index -= 1;
        saveStoredState();
        renderQuestion('back');
        scrollSkillCardIntoView();
      });

      const fullReset = () => {
        clearTimers();
        clearStoredState();
        state.index = 0;
        state.answers = {};
        state.mode = 'question';
        state.resultData = null;
        renderQuestion();
      };

      skillRoot.suityouSkillFinder = {
        reset: fullReset,
        getState: () => ({
          schema: STORAGE_SCHEMA,
          storageKey: STORAGE_KEY,
          currentQuestion: state.index,
          answers: { ...state.answers },
          mode: state.mode,
          result: state.resultData
        })
      };
      skillRoot.dataset.sySkillFinderReady = 'true';

      if (restoredState?.completed) {
        state.resultData = calculateResult();
        renderResult();
      } else {
        setProgress(questionProgress[state.index], `Question ${state.index + 1} of ${questions.length}`);
        progressFill.style.width = `${questionProgress[state.index]}%`;
        renderQuestion();
      }
    };

  const init = () => {
    document.querySelectorAll('[data-sy-skill-finder]').forEach(setupSkillFinderV2);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
